import { ENABLE_ANALYTICS } from '@/lib/constants';
import posthog from 'posthog-js';

class Analytics {
  constructor() {
    if (!ENABLE_ANALYTICS) {
      return;
    }
  }

  track(event: string, properties: object) {
    posthog?.capture(event, properties);
  }

  async identify(email: string) {
    posthog?.identify(email, { email });
  }

  reset() {
    posthog?.reset();
  }
}

const analytics = new Analytics();

export { analytics };
